var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Checkmark, Indeterminate } from '@amsterdam/asc-assets';
import React, { useContext, useEffect, useImperativeHandle, useMemo, useState, } from 'react';
import LabelContext from '../Label/LabelContext';
import CheckboxStyle, { CheckboxIconStyle, CheckboxWrapperStyle, } from './CheckboxStyle';
const Checkbox = React.forwardRef((_a, externalRef) => {
    var { checked: checkedProp, className, onChange, variant, disabled, error, indeterminate } = _a, otherProps = __rest(_a, ["checked", "className", "onChange", "variant", "disabled", "error", "indeterminate"]);
    const [checked, setChecked] = useState(!!checkedProp);
    const { setActive } = useContext(LabelContext);
    const ref = React.useRef(null);
    useImperativeHandle(externalRef, () => ref.current);
    useEffect(() => {
        if (ref.current) {
            ref.current.indeterminate = indeterminate !== null && indeterminate !== void 0 ? indeterminate : false;
        }
    }, [ref, indeterminate]);
    // Make the label aware of changes in the checked state
    useEffect(() => {
        setActive(checked);
    }, [checked, setActive]);
    // Make the component aware of changes in the checked prop
    useMemo(() => {
        setChecked(!!checkedProp);
    }, [checkedProp, setChecked]);
    return (React.createElement(CheckboxWrapperStyle, Object.assign({}, { className, disabled, checked, error }, { "aria-disabled": disabled }),
        React.createElement(CheckboxIconStyle, Object.assign({}, { disabled, variant, checked, error, indeterminate }, { size: 15 }),
            !checked && indeterminate && React.createElement(Indeterminate, null),
            checked && React.createElement(Checkmark, null)),
        React.createElement(CheckboxStyle, Object.assign({}, Object.assign(Object.assign({}, otherProps), { disabled, checked, ref }), { onChange: (e) => {
                if (onChange) {
                    onChange(e);
                }
                if (typeof checkedProp === 'undefined') {
                    setChecked(!checked);
                }
            } }))));
});
export default Checkbox;
//# sourceMappingURL=Checkbox.js.map